<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <form class="ft2-input-group">
        <ng-select [(ngModel)]="placeToAdd"
                   #selectModel="ngModel"
                   [hideSelected]="true"
                   [searchable]="true"
                   [clearable]="false"
                   [loading]="loading$ | async"
                   placeholder="Search nearby"
                   [typeahead]="searchTerm$"
                   [virtualScroll]="true"
                   (scrollToEnd)="onScrollToEnd()"
                   name="placesSearch"
                   class="ft2-select -no-arrow -large full-width">
            <ng-container *ngFor="let option of placesOptions$ | async">
                <ng-option *ngIf="!isOptionAlreadyAdded(option)" [value]="option">
                    <p>
                        {{ option?.[bindLabel] }}
                    </p>
                    <ng-container *ngTemplateOutlet="addressTmpl; context: { option: option}" />
                </ng-option>
            </ng-container>
        </ng-select>
        <div class="ft2-input-group_append">
            <button (click)="addItem()" [disabled]="!placeToAdd || selectModel?.invalid" type="submit" class="ft2-btn-primary">
                <mat-icon class="icon-xl">playlist_add</mat-icon>
            </button>
        </div>
    </form>
    <div class="ft2-edit-dialog_modal -options-list mt-3 pb-1">
        <ng-container *ngIf="listPlaceholder && !value?.length">
            {{ listPlaceholder }}
        </ng-container>
        <div class="ft2-list-editor-item f-row f-wrap v-center"
             *ngFor="let item of value; let i = index">
            <p class="full-width">
                {{ (item?.languageData | languagePreview: 'name' : currentLanguageCode) }}
                <ng-container *ngIf="showAmount">
                    <ng-container *ngFor="let amountEntry of (itemsAmountPerPlace$ | async)">
                        <ng-container *ngIf="(amountEntry.googlePlaceId == item.googlePlaceId)">
                            ({{ amountEntry.count || 0 }})
                        </ng-container>
                    </ng-container>
                </ng-container>
            </p>
            <ng-container *ngTemplateOutlet="addressTmpl; context: { option: item }" />
            <button class="ft2-btn-icon ml-1 ft2-list-editor-item_remove-btn" (click)="removeItem(i)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</ft-modal-editor-wrapper>


<ng-template #addressTmpl let-option="option">
    <ng-container *ngIf="option">
         <span class="muted-text" *ngIf="(option.languageData | languagePreview: 'fullAddress' : currentLanguageCode) as address; else addressFallback">
            {{ address }}
        </span>
    </ng-container>
    <ng-template #addressFallback>
        <span class="muted-text">
            {{ formatAddress(option) }}
        </span>
    </ng-template>
</ng-template>
